import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FruitTreeComponent } from './fruit-tree.component';
import { SharedModule } from '../shared/shared.module';



@NgModule({
  declarations: [FruitTreeComponent],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class FruitTreeModule { }
